import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';

import NavigationContainer from './NavigationContainer';
import MainTextComponent from './MainTextComponent';
import FactsComponent from './FactsComponent';
import * as AppActions from '../app/AppActions';
import './Style';

class HeroContainer extends Component {
    constructor() {
        super();

        this.state = {
            error: null,
            errorInfo: null,
            imgHeight: 0,
            sticky: true
        }
        // this.img = null
        // this.text = null
        this.handleScroll = this.handleScroll.bind(this)
        this.checkHeroPhoto = this.checkHeroPhoto.bind(this)
    }


    componentDidMount() {
        if (!this.props.backgroundPhoto) {
            this.props.appActions.getBackgroundPhoto();
        }
        // this.handleScroll();
        window.addEventListener('scroll', this.handleScroll, false);
        window.addEventListener('resize', this.handleScroll, false);
        window.addEventListener('message', (e) => {
            const { presentation } = e.data
            if (presentation) {
                this.setState({
                    presentation: true
                })
            }
        })

    }

    componentWillUnmount() {
        // window.removeEventListener('scroll', this.handleScroll)
    }

    componentWillReceiveProps() {
        // console.log('dsadasda', document.getElementById("imagHeroFoto").complete);
        this.checkHeroPhoto()
    }


    componentDidCatch(error, errorInfo) {
        this.setState({
            error,
            errorInfo
        }, () => {
            console.error(error, errorInfo);
        })
    }

    handleScroll(event) {

            if (!this.img || !this.text) {
                return
            }
            const height = document.getElementById('imagHeroFoto').clientHeight;
            const sticky = height >= pageYOffset + window.innerHeight
            sticky !== this.state.sticky && this.setState({
                sticky: sticky
            })

        }
        checkHeroPhoto = () => {
            const fun = this.handleScroll
            let timerId = setTimeout(function request() {
                fun();
                if (document.getElementById('imagHeroFoto').complete) {
                  return
                }

                timerId = setTimeout(request, 1);

              }, 1)
        }

        render() {
            const {
                propertyInfo,
                backgroundPhoto,
                theme,
                galleryExists,
                heroInfo,
                imageSizeParams
        } = this.props;

        const { error, sticky } = this.state;

        if (error || !galleryExists) {
            return null;
        };

        const getBackgroundPhotoUrl = (fallback) => {

            if (!backgroundPhoto) {
                return '';
            }
            const fullFilename = backgroundPhoto.path  + encodeURIComponent(backgroundPhoto.file_name);

            if (fallback) {
                return fullFilename + imageSizeParams.walk;
            }

            if (backgroundPhoto.type === 'gallery') {

                if (window.innerWidth < 375) {
                    return fullFilename + imageSizeParams.original;

                } else if (window.innerWidth < 640) {
                    return fullFilename + imageSizeParams.wide;

                } else if (window.innerWidth < 720) {
                    return fullFilename + imageSizeParams.wide;

                }
                return fullFilename + imageSizeParams.fullhd;

            } else {
                return fullFilename
            }
        }

        return (
            <div
                className="hero-container"
                id="imagHeroFoto"
                style={{ backgroundImage: `url("${getBackgroundPhotoUrl()}"), url("${getBackgroundPhotoUrl(true)}")` }}
            >
                <div className="hero-container-content">
                    <NavigationContainer />
                    <div className="hero-img">
                        <img style={{ width: '100%' }} ref={img => this.img = img} loading='eager' src={getBackgroundPhotoUrl()} alt="" />
                    </div>
                    <div
                        ref={text => this.text = text}
                        style={sticky ? { position: 'fixed', bottom: 0, width: '100%' } : { width: '100%', position: 'absolute', bottom: 0 }}>
                        <MainTextComponent propertyInfo={propertyInfo} theme={theme} heroInfo={heroInfo}/>
                        <FactsComponent heroInfo={heroInfo} propertyInfo={propertyInfo} />
                    </div>
                </div>
            </div>
        )
    }
}

HeroContainer.propTypes = {
    logo: PropTypes.string,
    propertyInfo: PropTypes.object
}

const mapStateToProps = (state) => {
    return {
        logo: state.agent.agentInfo.logo,
        propertyInfo: state.property.info,
        heroInfo: state.hero,
        backgroundPhoto: state.app.backgroundPhoto,
        galleryExists: state.gallery.galleryExists,
        imageSizeParams: state.gallery.imageSizeParams,
        theme: state.app.theme
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        appActions: bindActionCreators(AppActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(HeroContainer)
